import { AppBar, Grid, Toolbar } from "@mui/material";
import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EmptyList,
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDialog,
	EnhancedSnackbar,
	IResponse,
	IServerError,
} from "@websential/cosmic-v20";
import {
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../common/constants";
import React, {
	useCallback,
	useEffect,
	useMemo,
	useRef,
	useState,
} from "react";
import { checkSINValidity, formatDate, getDDLLabelByValueForDraftEmployee, getDDLValueByLabel, getDDLValueByLabelForDraftEmployee, getProvinceDDLLabelByShortCode, useNavigateToLogout, useRemoveQueriesOnUnmount } from "../../common/Common";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { ClientService } from "../../services";
import { CountryService } from "../../services/common/CountryService";
import DraftEmployeeDataGrid from "./DraftEmployeeDataGrid";
import { EmployeeService } from "../../services/EmployeeService";
import { IAppState } from "../../store/reducers";
import { IGetListRequest } from "../../models";
import PrimeDataGrid from "./DraftEmployeeDataGrid";
import { ProgressBar } from "primereact/progressbar";
import { T4SlipService } from "../../services/T4SlipService";
import { draftEmployeeHeaderColumns } from "./DraftEmployeeHeaderColumns";
import { setSelectedDrawerOptionsMenu } from "../../store/actions/drawerMenuOptionsActions";
import { setSelectedStickyNavBar } from "../../store/actions";
import { useNavigate } from "react-router-dom";

const formatSnackbarMessage = (message: any, errors: any): any => {
	// const { message, errors } = data.message;

	if (!errors?.length) {
		return message;
	}

	// const numberedErrors = errors
	// 	.map((err: any, index: any) => `${index + 1}. ${err}`)
	// 	.join("\n");

	// return `${message}\n\n${numberedErrors}`;

	return (
		<>
			<div>{message}</div>
			<ul style={{ margin: "8px 0 0", paddingLeft: "20px" }}>
				{errors.map((err: any, index: any) => (
					<li key={index}>{err}</li>
				))}
			</ul>
		</>
	);
};
const DEFAULT_SETTINGS_DATA_QUERY_KEY = "default-settings-data-record";

// const useGetDefaultSettingsData = (
//   clientId: string,
// ) =>
//   useQuery(
//     [DEFAULT_SETTINGS_DATA_QUERY_KEY, clientId],
//     (data) => {
//       return DefaultSettingsService.getDefaultSettings(clientId);
//     },
//     { refetchOnWindowFocus: false }
//   );
const EMPLOYEE_DRAFT_LIST_QUERY_KEY = "draft-employee-list";
const useDraftEmployee = (
	clientId: string,
	params: IGetListRequest,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [EMPLOYEE_DRAFT_LIST_QUERY_KEY, params],
		queryFn: (data) => {

			return EmployeeService.getDraftEmployee(
				clientId,
				params,
				navigateToLogout
			);
		},
		refetchOnWindowFocus: false,
	});

const useGetCountryDDL = () =>
	useQuery({
		queryKey: ["country-ddl"],
		queryFn: (data) => {
			return CountryService.getCountryDDL();
		},
		refetchOnWindowFocus: false,
	});
const useGetPayFrequencyDDL = (clientId: string, taxYear: number) =>
	useQuery({
		queryKey: ["pay-frequency-ddl"],
		queryFn: (data) => {
			return EmployeeService.getPayFrequencyDDL(clientId, taxYear);
		},
		refetchOnWindowFocus: false,
	});

const CLIENT_INFO_DATA_QUERY_KEY = "client-info-data-record";
const useGetClientInformationById = (
	id: string | undefined,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [CLIENT_INFO_DATA_QUERY_KEY, id, navigateToLogout],
		queryFn: (data) => {
			return ClientService.getSimpleClientById(id, navigateToLogout);
		},
		refetchOnWindowFocus: false,
	});
export interface IDraftEmployeesLayout { }
export const DraftEmployeesLayout: React.FC<IDraftEmployeesLayout> = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const interval = useRef<any>(null);
	const queryClient = useQueryClient();
	const taxYear = useSelector((state: IAppState) => state.taxYear.year);
	const clientId = useSelector((state: IAppState) => state.client.id);
	const navigateToLogout = useNavigateToLogout();
	const [openDialog, setDialogOpen] = useState(false);
	const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [onDataSubmit, setOnDataSubmit] = useState<any>(undefined);
	const [percentageValue, setPercentageValue] = useState(0);
	const [selectedRowsValues, setSelectedRowsValues] = useState([]);
	const [selectedEmployeeDraftListItems, setSelectedEmployeeDraftListItems] =
		useState([]);

	// const companyInformation = useSelector((state: IAppState) => state.dashboardApisData.client_detail)
	const [zeroEmployee, setzeroEmployee] = useState(true);
	const [employeeDraftListTableData, setEmployeeDraftListTableData] = useState(
		[]
	);
	const [selectedIds, setSelectedIds] = useState([]);
	const [draftEmployeeId, setDraftEmployeeId] = useState<number>(0);
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};
	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "firstName",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "firstName",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
		setzeroEmployee(false);
	}, []);

	const { isPending: isPendingClientInformationById, data: companyInformation } = useGetClientInformationById(
		clientId,
		navigateToLogout
	);

	const { isPending, data } = useDraftEmployee(
		clientId,
		queryParams,
		navigateToLogout
	); //useQuery('accountants-list', AccountantService.getAccountantList, { refetchOnWindowFocus: false });
	const employeeDraftList: any | null = data;


	const { isPending: isPendingCountryDDL, data: countryList } =
		useGetCountryDDL();
	const { isPending: isPendingPayFrequencyDDL, data: payFrequencyDDLItems } =
		useGetPayFrequencyDDL(clientId, taxYear);


	const [provinceOfEmployementDDL, setprovinceOfEmployementDDL] =
		useState<any>(undefined);
	useEffect(() => {
		if (countryList && Array.isArray(countryList)) {
			const canada = countryList.find(
				(item: any) => item.label === "Canada" || "canada"
			);
			if (canada) {
				(async () => {
					try {
						const response = await CountryService.getProvinceOrStateDDL(
							navigateToLogout,
							canada.value,
							"Province"
						);
						setprovinceOfEmployementDDL(response);
					} catch (err) {
						console.error("error", err);
					}
				})();
			} else {
				setprovinceOfEmployementDDL(undefined);
			}
		}
	}, [countryList]);

	const upadtedEmployeeDraftListItems = useMemo(() => {
		return (
			employeeDraftList &&
			employeeDraftList.items &&
			employeeDraftList?.items.map((item: any) => ({
				...item,
				// empTitle: (
				// 	<Link
				// 		to={`/employee/setup/${item.id}`}
				// 		className="no-underline"
				// 		style={{ color: theme.palette.primary.light }}
				// 	>
				// 		{item.empTitle}
				// 	</Link>
				// ),
				provinceOfEmployment:
					item.provinceOfEmployment && item.provinceOfEmployment.id
						? item.provinceOfEmployment.id
						: getProvinceDDLLabelByShortCode(provinceOfEmployementDDL, item.provinceOfEmployment),
				country:
					item.country && item.country.id ? item.country.id : item.country,
				province:
					item.province && item.province.id ? item.province.id : getProvinceDDLLabelByShortCode(provinceOfEmployementDDL, item.province),
				states: item.states && item.states.id ? item.states.id : item.states,
				city: item.city && item.city.id ? item.city.id : item.city,
				payFrequency: getDDLValueByLabelForDraftEmployee(payFrequencyDDLItems, item.payFrequency)
			}))
		);
	}, [employeeDraftList, provinceOfEmployementDDL, payFrequencyDDLItems]);

	const { isPending: isSubmittingTemporaryData, mutate: submitTemporaryData } =
		useMutation({
			mutationFn: T4SlipService.submitTemporaryData,
			onSuccess: (res: any | IServerError | IResponse) => {

				if (
					res.message ===
					`${res.totalFetched} Records found and fetching started`
				) {
					setDialogOpen(true)
					const SubmitActualDataApi = async () => {
						try {
							const response: any = await EmployeeService.submitUpdatedRowsFromCsv(onDataSubmit, res.id);

						} catch (error) {
							console.error("Error fetching data:", error);
						}
					};
					SubmitActualDataApi();
					setSnackbarData({
						open: true,
						message: res.message,
						severity: "success",
					});

					//manage progress bar
					let _val = percentageValue;
					const fetchData = async () => {
						try {
							const response: any = await T4SlipService.temporaryItemsCount(res.id);

							_val = Math.floor((response.counter / res.totalFetched) * 100);
							
							setPercentageValue(_val);

							if (response.counter >= res.totalFetched) {
								clearInterval(interval.current);
								setPercentageValue(100)

								let totalSuccessfullImportedItems = response.counter - response.fail
								// setSnackbarData({
								// 	open: true,
								// 	message: `${totalSuccessfullImportedItems} items imported and ${response.fail} items have incorrect data.`,
								// 	severity: totalSuccessfullImportedItems === 0 ? "warning" : "success",
								// });
								if (response.data) {
								
									setSnackbarData({
										open: true,
										message: formatSnackbarMessage(response.data.message, response.data.errors),
										severity: response.data.errors && response.data.errors.length > 0 ? "warning" : "success",
									})
								}
								queryClient.invalidateQueries({
									queryKey: [EMPLOYEE_DRAFT_LIST_QUERY_KEY],
								});
								// Set up the interval
								interval.current = setInterval(() => {
									setDialogOpen(false)
									clearInterval(interval.current);
								}, 3000);
								return queryClient.invalidateQueries({
									queryKey: [EMPLOYEE_DRAFT_LIST_QUERY_KEY],
								});
							}


						} catch (error) {
							console.error("Error fetching data:", error);
						}
					};

					// Set up the interval
					interval.current = setInterval(() => {
						fetchData();
					}, 10000);

				} else {
					setSnackbarData({
						open: true,
						message: `${res.message ? res.message : "importing Failed."}`,
						severity: "error",
					});
				}
			},
			onError: (err: any) => {
				setSnackbarData({
					open: true,
					message: err.message,
					severity: "error",
				});
			},
		});

	const { isPending: isSubmittingUpdatedRows, mutate: submitUpdatedRows } =
		useMutation({
			mutationFn: T4SlipService.submitTemporaryData,
			onSuccess: (res: any | IServerError | IResponse) => {

				if (res.message === `${res.totalFetched} Records found and fetching started`) {
					// setSnackbarData({
					// 	open: true,
					// 	message: res.data.message ? res.data.message : "Data has been submitted successfully.",
					// 	severity: "success",
					// });

					(async () => {
						try {
							setSnackbarData({
								open: true,
								message: res.message,
								severity: "success",
							});
							setDialogOpen(true)
							setPercentageValue(10)
							const response: any = await EmployeeService.submitUpdatedRowsFromCsv(onDataSubmit, res.id);

							//manage progress bar
							if (response.status === 200) {
								setPercentageValue(100)
								setTimeout(() => {
									setDialogOpen(false)
								}, 1000)
								queryClient.invalidateQueries({
									queryKey: [EMPLOYEE_DRAFT_LIST_QUERY_KEY],
								});
								if (response.data.message) {
									
									// setSnackbarData({
									// 	open: true,
									// 	message: response.data.message,
									// 	severity: response.data.message.startsWith("0") ? "warning" : "success",
									// });
									setSnackbarData({
										open: true,
										message: formatSnackbarMessage(response.data.message, response.data.errors),
										severity: response.data.errors && response.data.errors.length > 0 ? "warning" : "success",
									})
								}
							} else {
								setDialogOpen(false)
								setSnackbarData({
									open: true,
									message: response.message ? response.message : "Something went wrong.",
									severity: "error",
								});
							}
						} catch (error) {
							console.error("Error fetching data:", error);
						}
					})();

					return queryClient.invalidateQueries({
						queryKey: [EMPLOYEE_DRAFT_LIST_QUERY_KEY],
					});
				} else {
					setSnackbarData({
						open: true,
						message: res.message
							? res.message
							: "Something went wrong, try again later!",
						severity: "error",
					});
				}
			},
			onError: (err: any) => {
				setSnackbarData({
					open: true,
					message: err.message,
					severity: "error",
				});
			},
		});
	// const { isPending: isSubmittingUpdatedRows, mutate: submitUpdatedRows } =
	// 	useMutation({
	// 		mutationFn: EmployeeService.submitUpdatedRowsFromCsv,
	// 		onSuccess: (res: any | IServerError | IResponse) => {

	// 			if (res.status === 200) {
	// 				// setSnackbarData({
	// 				// 	open: true,
	// 				// 	message: res.data.message ? res.data.message : "Data has been submitted successfully.",
	// 				// 	severity: "success",
	// 				// });

	// 				setSnackbarData({
	// 					open: true,
	// 					message: res.message,
	// 					severity: "success",
	// 				});

	// 				return queryClient.invalidateQueries({
	// 					queryKey: [EMPLOYEE_DRAFT_LIST_QUERY_KEY],
	// 				});
	// 			} else {
	// 				setSnackbarData({
	// 					open: true,
	// 					message: res.message
	// 						? res.message
	// 						: "Something went wrong, try again later!",
	// 					severity: "error",
	// 				});
	// 			}
	// 		},
	// 		onError: (err: any) => {
	// 			setSnackbarData({
	// 				open: true,
	// 				message: err.message,
	// 				severity: "error",
	// 			});
	// 		},
	// 	});

	const requiredFields = [
		"firstName",
		"lastName",
		"dateOfBirth",
		"addressLine1",
		"country",
		"province",
		"states",
		"postCode",
		"zipCode",
		"dateOfHire",
		"provinceOfEmployment",
	];

	const validateSelectedItems = (items: any[]) => {
		const allErrors: string[] = [];
		const validPayload: any[] = [];



		const itemsWithCountryOrProvinceObjects = items.map((item) => {
			const regenrateProvinceDDLItems = provinceOfEmployementDDL.map(({ label, value, shortCode }: any) => ({
				name: label,
				id: value,
				shortCode,
			}));


			const selectedProvince = regenrateProvinceDDLItems.find(
				(sc: any) => item.province === sc.shortCode || item.province === sc.id || item.province === sc.name
			);
			const selectedProvinceOfEmployment = regenrateProvinceDDLItems.find(
				(sc: any) => item.provinceOfEmployment === sc.shortCode || item.provinceOfEmployment === sc.id || item.provinceOfEmployment === sc.name
			);
		
			const match = employeeDraftList?.items.find((d: any) => d.shortCode === item.shortCode);
			return {
				...item,
				province: selectedProvince || undefined,
				addressLine1: item.address,
				country: countryList && { id: countryList[0].value, name: countryList[0].label, shortCode: countryList[0].shortCode },
				state: selectedProvince || undefined,
				// city: match?.city || undefined,
				provinceOfEmployment: selectedProvinceOfEmployment,
			};
		});

		itemsWithCountryOrProvinceObjects.forEach((item, index) => {
			const selectedPayFrequency = payFrequencyDDLItems && payFrequencyDDLItems.find((x: any) => x.value === getDDLValueByLabel(payFrequencyDDLItems, item.payFrequency))

			const missingFields: string[] = [];
			const sin = item?.socialInsuranceNumber;

			requiredFields.forEach((field) => {
				const value = item?.[field];

				

				if (
					// field === "provinceOfEmployment"
					// 	? !value
					// 	: value === null || value === ""
					(field === "provinceOfEmployment") && (!value || value === null || value === "")
				) {
					const fieldLabel = field
						.replace(/([A-Z])/g, " $1")
						.replace(/^./, (str) => str.toUpperCase());

					missingFields.push(fieldLabel.trim());
				}
			});

			if (missingFields.length > 0) {
				allErrors.push(`${missingFields.join(" and ")} value is missing`);
				return; // Skip this item
			}

			if (sin && sin.trim() !== "") {
				const cleanedSIN = sin.replace(/-/g, "");
				const isValid = checkSINValidity(cleanedSIN);

				if (cleanedSIN.length !== 9 || isValid % 10 !== 0) {
					allErrors.push(`Invalid Social Insurance Number ❌`);
					return; // Skip this item
				}
			}

			// If all validations passed, push to payload
			validPayload.push({
				employeeId: item.employeeId,
				clientId: clientId,
				firstName: item.firstName,
				lastName: item.lastName,
				initial: item.initial,
				gender: item.gender,
				dateOfBirth: formatDate(item.dateOfBirth),
				socialInsuranceNumber: item.socialInsuranceNumber,
				// address: {
				countryType: true,
				country: item.country,
				province: item.province,
				states: item.states,
				address: item.addressLine1,
				city: item.city,
				postCode: item.postCode,
				phone: item.phone,
				email: item.email,
				// },
				// employeeSetub: {
				stubLanguage: item.stubLanguage,
				emailStub: item.emailStub,
				printHourlyRateOnStub: item.printHourlyRateOnStub,
				stubNotes: item.stubNotes,
				// },
				// employeeBank: {
				account1Name: item.account1Name,
				accountNo: item.accountNo,
				branchTransitNumber: item.branchTransitNumber,
				bankFinancialNo: item.bankFinancialNo,
				account2Name: item.account2Name,
				account2No: item.account2No,
				branchTransitNumberForAccount2: item.branchTransitNumberForAccount2,
				bankFinancialNoForAccount2: item.bankFinancialNoForAccount2,
				split: item.split,
				percenagePerDollorInAccount1: item.percenagePerDollorInAccount1,
				// },
				// employeePayroll: {
				payFrequency: item.payFrequency && getDDLValueByLabel(payFrequencyDDLItems, item.payFrequency),
				payPeriod: selectedPayFrequency && selectedPayFrequency.payPeriodCode,
				dateOfHire: formatDate(item.dateOfHire),
				payMethod: companyInformation && companyInformation.paymentSetup === 100 ? 200 : item.payMethod,
				provinceOfEmployment: item.provinceOfEmployment,
				includeInT4OrRl1: item.includeInT4OrRl1,
				dentalBenefits: item.dentalBenefits,
				vacationPay: item.vacationPay,
				payOutVacationPay: item.payOutVacationPay,
				vacationPayOpenBalance: item.vacationPayOpenBalance,
				// },
				// additionalInformation: {
				datePensionBecomePayable: item.datePensionBecomePayable,
				rppOrDpspRegistrationNumber: item.rppOrDpspRegistrationNumber,
				dateOfDisability: item.dateOfDisability,
				dateDisabilityWasCeased: item.dateDisabilityWasCeased,
				// },

				// salary profile
				cppQppExempt: item.cppQppExempt,
				eiExempt: item.eiExempt,
				federalTaxExempt: item.federalTaxExempt,
				provisionalTaxExempt: item.provisionalTaxExempt,
				qpipExempt: item.qpipExempt,
				csstExempt: item.csstExempt,
				otherFederalTaxCreditsAuthorizedByTaxCenterMedicalExpensesChartiableDonations: item.otherFederalTaxCreditsAuthorizedByTaxCenterMedicalExpensesChartiableDonations,
				otherAnnualProvincialNonRefundableTaxCreditsAuthorizedByTaxCenter: item.otherAnnualProvincialNonRefundableTaxCreditsAuthorizedByTaxCenter,
				numberOfDisabledDependants: item.numberOfDisabledDependants,
				boughtApprovedSharesOfCapitalStockOfAPrescribedLaborSponsoredVentureCapitalCorp: item.boughtApprovedSharesOfCapitalStockOfAPrescribedLaborSponsoredVentureCapitalCorp,
				noOfDependantsUnderAge18ForWhichTheEmployeeOrHasMadeAWrittenRequest: item.noOfDependantsUnderAge18ForWhichTheEmployeeOrHasMadeAWrittenRequest,
				minVocationPayOfGross: item.minVocationPayOfGross,
				howIsEmployPaid: item.howIsEmployPaid,
				regularSalaryForThePeriod: item.regularSalaryForThePeriod,
				id: item.id,
			});
		});

		if (allErrors.length > 0) {
			// Show first error or all errors, up to you
			setSnackbarData({
				open: true,
				message: allErrors.join("\n"),
				severity: "error",
			});
		} else {
			
			const hasNullPayFrequency = validPayload.some(item => item.payFrequency === null);
			if (hasNullPayFrequency) {
				setSnackbarData({
					open: true,
					message: 'Payroll Schedule is required',
					severity: "error",
				});
			} else {
				const hasIncorrectData = validPayload.some(employee => {
					const { payFrequency, dateOfHire } = employee;

					// Find matching frequency from DDL
					const matchedFrequency = payFrequencyDDLItems.find((f: any) => f.value === payFrequency);
					

					// If no match found, treat as incorrect
					if (!matchedFrequency || !matchedFrequency.endDate || !dateOfHire) return false;

					
					// endDate must be greater than dateOfHire
					// dateOfHire <= lastPeriodDate
					return new Date(dateOfHire) <= new Date(matchedFrequency.endDate);
				});
				if (hasIncorrectData) {
					setSnackbarData({
						open: true,
						message: "Employee's date of hire must be after last processed pay period end date.",
						severity: "error",
					});
				} else {
					if (validPayload && validPayload.length > 5) {
						let payload = {
							requestPayload: { "items": validPayload },
							clientId: clientId
						}
						setOnDataSubmit(payload)
						submitTemporaryData(payload);
					} else {
						let payload = {
							requestPayload: { "items": validPayload },
							clientId: clientId
						}
						setOnDataSubmit(payload)
						submitUpdatedRows(payload);
					}
				}
			}



			// let payload = {
			// 	requestPayload: { "items": validPayload },
			// 	clientId: clientId
			// }
			// submitUpdatedRows(payload);
		}
	};

	const onSubmitButtonClickedHandler = () => {


		const updatedSelectedEmployeeDraftListDataItems =
			employeeDraftListTableData.filter((x: any) =>
				selectedEmployeeDraftListItems.some((y: any) => y.id === x.id)
			);

		if (
			updatedSelectedEmployeeDraftListDataItems &&
			updatedSelectedEmployeeDraftListDataItems.length > 0
		) {

			const validatedData = validateSelectedItems(
				updatedSelectedEmployeeDraftListDataItems
			);

		} else {
			setSnackbarData({
				open: true,
				message: "Please select atleast one item.",
				severity: "warning",
			});
		}
	};

	const { isPending: isSubmittingSaveAsDraftRows, mutate: submitSaveAsDraftRows } =
		useMutation({
			mutationFn: EmployeeService.submitSaveAsDraftRowsFromCsv,
			onSuccess: (res: any | IServerError | IResponse) => {
				if (res.status === 200) {
					// setSnackbarData({
					// 	open: true,
					// 	message: res.data.message ? res.data.message : "Something went wrong.",
					// 	severity: "success",
					// });

					return queryClient.invalidateQueries({
						queryKey: [EMPLOYEE_DRAFT_LIST_QUERY_KEY],
					});
				} else {
					setSnackbarData({
						open: true,
						message: res.message
							? res.message
							: "Something went wrong, try again later!",
						severity: "error",
					});
				}
			},
			onError: (err: any) => {
				setSnackbarData({
					open: true,
					message: err.message,
					severity: "error",
				});
			},
		});

	const validateSelectedItemsForSaveAsDraft = (items: any[]) => {
		const itemsWithoutId = items.map((item) => {
			return {
				...item,
				id: undefined,
				employeeId: item.employeeId,
				clientId: clientId,
			};
		});

		const hasEmptyObject = itemsWithoutId.some(item =>
			Object.values(item).every(v => v === null || v === "")
		);

		if (hasEmptyObject) {
			setSnackbarData({
				open: true,
				message: "Please select item which have atleast one value!",
				severity: "warning",
			});
		} else {
			let payload = {
				requestPayload: { "items": itemsWithoutId },
				clientId: clientId
			}
			submitSaveAsDraftRows(payload);
		}
	}
	const onSaveAsDraftButtonClickedHandler = () => {

		// alert("clicked");

		const updatedSelectedEmployeeDraftListDataItems = employeeDraftListTableData.filter(
			(x: any) => selectedEmployeeDraftListItems.some((y: any) => y.id === x.id)
		);

		if (updatedSelectedEmployeeDraftListDataItems && updatedSelectedEmployeeDraftListDataItems.length > 0) {

			const validatedData = validateSelectedItemsForSaveAsDraft(updatedSelectedEmployeeDraftListDataItems);

		} else {
			setSnackbarData({
				open: true,
				message: "Please select atleast one item.",
				severity: "warning",
			});
		}
	};


	const onCloseHandler = () => {
		setDialogOpen(false);
		setOpenDeleteDialog(false);
		setSingleDelete(false);
	};



	const selectionToolbar = useCallback((selectedItems: any) => {
		// setSelectedIds(selectedItems);
		setSelectedEmployeeDraftListItems(selectedItems);
		// if (selectedItems.length) {
		// 	return (
		// 		// <Box sx={{ marginTop: theme.spacing(1) }}>
		// 		// 	<Button
		// 		// 		onClick={() => onRowMultipleDeleteClicked(selectedItems)}
		// 		// 		variant="contained"
		// 		// 		color="error"
		// 		// 	>
		// 		// 		Delete
		// 		// 	</Button>
		// 		// </Box>
		// 		<></>
		// 	);
		// }
		return (
			// <Box sx={{ marginTop: theme.spacing(1) }}>
			// 	<RouterLinkButton to="/employee/setup" text="Add Employee" />
			// </Box>
			<></>
		);
	}, [selectedRowsValues]);

	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const expandedLabels = ["Employee"];
	const expandedEmployeeDraftOrSetupItem = "Draft";
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Employee" &&
				item.label === expandedEmployeeDraftOrSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedEmployeeDraftOrSetupItem && "/employee/draft",
			};
			return enhancedItem;
		});
	};

	const { isPending: isDeleting, mutate: deleteDraftEmployeeById } = useMutation({
		mutationFn: EmployeeService.deleteDraftEmployeeById,
		onSuccess: (res: string | IServerError | IResponse | any) => {
			if (
				typeof res === "object" &&
				res?.message === "Draft Employee has been deleted successfully"
			) {
				queryClient.invalidateQueries({
					queryKey: [EMPLOYEE_DRAFT_LIST_QUERY_KEY],
				});

				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			let path = `/employee/draft`;
			navigate(path);
		},
		onError: () => {
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const deleteDraftEmployeeField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let payload = {
				draftEmployeeId: draftEmployeeId,
				navigateToLogout: navigateToLogout
			}
			deleteDraftEmployeeById(payload);
			setOpenDeleteDialog(false);
		}
	};
	// const deleteDraftEmployeeField = () => {
	// 	if (singleDelete) {
	// 		setSingleDelete(false);
	// 		setOpenDeleteDialog(false);

	// 		// If draftEmployeeId is a random string (new unsaved row), no API call needed
	// 		// Real IDs from API are numbers; new row IDs are random 5-char strings like "aB3xZ"
	// 		const isNewRow = draftEmployeeId;
	// 		if (!isNewRow) {
	// 			let payload = {
	// 				draftEmployeeId: draftEmployeeId, // check later working or not
	// 				navigateToLogout: navigateToLogout,
	// 			};
	// 			deleteDraftEmployeeById(payload);
	// 		}
	// 	}
	// };
	const onDeleteClicked = (params: any) => {
		// alert(params.id)
		// alert("yes")
		setOpenDeleteDialog(true);
		setSingleDelete(true);
		// if (employeeDraftList) {
		// setDraftEmployeeId(employeeDraftList.id);

		setDraftEmployeeId(params.id);
		// }
	};
	// 	const onDeleteClicked = () => {
	// 	if (selectedEmployeeDraftListItems.length === 0) return;

	// 	const selectedIds = selectedEmployeeDraftListItems.map((item: any) => item.id);
	
	// 	alert(`Deleting row ID(s): ${selectedIds.join(", ")}`);

	// 	setOpenDeleteDialog(true);
	// 	setSingleDelete(true);
	// 	// Set first selected item's id (for single delete flow)
	// 	setDraftEmployeeId(selectedIds[0]);
	// };

	const onRowDeleteClicked = useCallback((params: any) => {
		
		alert(`Row ID to delete: ${params.id}`);
		setDialogOpen(true);
		setSingleDelete(true);
		setDraftEmployeeId(params.id);
	}, []);

	const onRowEditClicked = useCallback((params: any) => {
	
		// alert(`Edit row with ID: ${params.row.id} has been clicked!`);
		let path = `/employee/draft`;
		navigate(path);
	}, []);



	useEffect(() => {
		dispatch(setSelectedStickyNavBar({ isSticky: false }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	// reset data after leaves component
	useRemoveQueriesOnUnmount([EMPLOYEE_DRAFT_LIST_QUERY_KEY]);

	const image =
		"https://taxslips.blob.core.windows.net/taxslips-public-images-container/empty_employee_list.png";
	return employeeDraftList &&
		employeeDraftList.items &&
		employeeDraftList.items.length === 0 
		// && zeroEmployee === true
		 ? (
		<EmptyList
			showImage={true}
			imagePath={image}
			heading={`There's nothing! Import Employee to proceed`}
			content={`You can import Employee by directly clicking on import Employee button.`}
			testId={"draft-import-empty-list"}
			showAddButton={true}
			addButtonLabel={"Import Employee"}
			navigateToAdd={"/employee/import"}
			showImportButton={false}
			showImportXmlButton={false}
		/>
	) : (
		<>
			<Grid
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				sx={{ width: "100%", overflow: "hidden" }}
			>
				<BackdropCircularProgress
					open={
						isPending ||
						isSubmittingSaveAsDraftRows ||
						isSubmittingUpdatedRows ||
						isSubmittingTemporaryData || isDeleting || isPendingClientInformationById
					}
					testId="DraftEmployeesLayout"
				/>

				<DeleteConfirmationDialog
					open={openDeleteDialog}
					deleteActionHandler={deleteDraftEmployeeField}
					cancelActionHandler={onCloseHandler}
					testId="draft-employee-confirmation-dialog"
				/>
				<DraftEmployeeDataGrid
					rows={
						employeeDraftList && upadtedEmployeeDraftListItems
							? upadtedEmployeeDraftListItems
							: []
						// itams
					}
					// columns={employeeDraftList ? employeeDraftList?.headerColumns : []}
					columns={draftEmployeeHeaderColumns}
					showIndexColumn={true}
					showChecboxColumn={true}
					showSettingColumn={true}
					onRowEditClicked={onRowEditClicked}
					// onRowDeleteClicked={onRowDeleteClicked}
					onRowDeleteClicked={(data: any) => onDeleteClicked(data)}
					isLoading={isDeleting}
					onSnackbarMessageData={(value: any) => setSnackbarData(value)}
					totalRecords={
						employeeDraftList && employeeDraftList.total
							? employeeDraftList.total
							: 0
					}
					initialPageSize={INITIAL_PAGE_SIZE}
					rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
					onRequestParamsChange={onRequestParamsChange}
					selectionToolbar={selectionToolbar}
					selectedRowsValues={(value: any) => setSelectedRowsValues(value)}
					searchFieldPlaceholder={"Search..."}
					pageTitle={"Draft Employee"}
					provinceOfEmployementDDL={provinceOfEmployementDDL}
					countryList={countryList ?? []}
					employeeDraftListTableData={(data: any) =>
						setEmployeeDraftListTableData(data)
					}
					payFrequencyDDLItems={payFrequencyDDLItems && payFrequencyDDLItems}
					companyInformation={companyInformation}


				/>

				{employeeDraftList && provinceOfEmployementDDL ? (
					<AppBar
						position="sticky"
						color="default"
						elevation={1}
						sx={{
							// backgroundColor: "#fff",
							backgroundColor: "#F7F7F7",
							// marginTop: theme.spacing(3),
							boxShadow: "none",
							alignItems: "center",
							zIndex: 0,
							position: "sticky",
							bottom: 0,
						}}
					>
						<Toolbar>
							{companyInformation && companyInformation.status !== 100 && <span style={{ marginRight: "1rem", fontSize: ".875rem" }}>
								Employees can only be created in Active accounts.
							</span>} <EnhancedButtonPrimeReact
								label="Submit"
								// type="submit"
								onClickHandler={onSubmitButtonClickedHandler}
								// icon="pi pi-check"
								raised
								severity={EnhancedButtonPrimeReactSeverity.Success}
								disabled={companyInformation && companyInformation.status !== 100 ? true : false}
							/>
							<EnhancedButtonPrimeReact
								label="Save as draft"
								// type="submit"
								onClickHandler={onSaveAsDraftButtonClickedHandler}
								// icon="pi pi-check"
								style={{ marginLeft: "10px" }}
								raised
								severity={EnhancedButtonPrimeReactSeverity.Secondary}
							/>
							{/* <EnhancedButtonPrimeReact
								label="Delete"
								onClickHandler={onDeleteClicked}
								style={{ marginLeft: "10px" }}
								raised
								severity={EnhancedButtonPrimeReactSeverity.Danger}
								disabled={selectedEmployeeDraftListItems.length === 0}
							/> */}
						</Toolbar>
					</AppBar>
				) : (
					<></>
				)}

				<EnhancedDialog
					dialogTitle={`Importing`}
					key="dialog-box"
					testId="dialog"
					onCloseHandler={onCloseHandler}
					// showCloseButton={false}
					open={openDialog}
					dialogContent={
						<ProgressBar
							value={percentageValue}
							pt={{
								value: { style: { background: 'linear-gradient(to right, #8e2de2, #4a00e0)' } }
							}}
						></ProgressBar>
					}
					dialogAction={
						<></>
					}
				/>

				<EnhancedSnackbar
					message={snackbarData.message}
					onCloseHandler={onSnackbarClosed}
					severity={snackbarData.severity}
					testId={`DraftEmployeesLayout-snackbar`}
					open={snackbarData.open}
				/>
			</Grid>
		</>
	);
};
